import { royalcaninDogProducts } from '../Assets/Product_Info/royalcaninDogProducts'
import { royalcaninCatProducts } from '../Assets/Product_Info/royalcaninCatProducts'
import { petFoodProducts } from '../Assets/Product_Info/petFoodProducts'

const productMap = {}
for (const p of royalcaninDogProducts) productMap[p.id] = { ...p, link: `/Product/${p.id}` }
for (const p of royalcaninCatProducts) productMap[p.id] = { ...p, link: `/Product/${p.id}` }
for (const p of petFoodProducts) productMap[p.id] = { ...p, link: `/Product/${p.id}` }

export default productMap
